import {ref, onUnmounted} from '@vue/composition-api';

export function useCrisisFormUpdate(idForm) {
  const lastUpdate = ref(null);
  const channelName = `operational-security-crisis-form-${idForm}`;

  setTimeout(() => {
    window.Echo.private(channelName)
      .listen('.form.updated', () => {
        lastUpdate.value = Date.now();
      });
  }, 1000);

  onUnmounted(() => {
    window.Echo.leave(channelName);
  });

  return {lastUpdate};
}
